import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { connect } from 'react-redux';
import { FileSelection } from '../../containers/Files';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import withAuth from '../../hocs/withAuth';
import { createUser, updateReferenceCode } from '../../store/actions/auth';
import { updateBrandPicture } from '../../store/actions/brand';
import { showLoader } from '../../store/actions/loader';
import ButtonContent from '../ButtonContent';
import NavigationTabs from '../nav/NavigationTabs';
import { AlertJsMessage } from '../../helpers.js'

class AddBrand extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			password: '',
			displayName: '',
			profileImgUrl: '',
			activeCompaignTag: '',
			profileFileId: 0,
			productUrl: '',
			productImgUrl: '',
			referralImgUrl: '',
			referralFileId: 0,
			referenceCode: '',
			showSuccessMessage: false,
			isContentRestrict: false,
			isFullLibraryVisible: false,
			isLibraryExerciseHide: false,
			creatorId: '',
			successMsg: '',
		};
	}

	static getDerivedStateFromProps(props, state) {
		let updateSate = null;
		const { brand } = props;
		if (brand) {
			updateSate = {
				...props.brand,
			};
		}
		return updateSate;
	}

	handleChange = field => event => {
		this.setState({
			...this.state,
			[field]: event.target.value,
		});
	};

	handleRestrictApp = field => event => {
		this.setState({
			...this.state,
			[field]: event.target.checked,
		});
	};

	handleFullLibraryVisible = field => event => {
		this.setState({
			...this.state,
			[field]: event.target.checked,
		});
	};

	handleChatbot = field => event => {
		this.setState({
			...this.state,
			[field]: event.target.checked,
		});
	};

	handleHideExerciseHide = field => event => {
		this.setState({
			...this.state,
			[field]: event.target.checked,
		});
	};


	clearFields = () => {
		this.setState({
			email: '',
			password: '',
			activeCompaignTag: '',
			creatorId: '',
			displayName: '',
			profileImgUrl: '',
			profileFileId: 0,
			productUrl: '',
			productImgUrl: '',
			referralImgUrl: '',
			referralFileId: 0,
			referenceCode: '',
			isContentRestrict: false,
			isChatbot: false,
			isFullLibraryVisible: false,
			isLibraryExerciseHide: false
		});
		this.productFile && this.productFile.clearImage();
		this.referralFile && this.referralFile.clearImage();
	};

	updateBrand() {
		const { type, selectedFile, previewImageSrc } = this.productFile.state;
		const { updateBrandPicture, removeError, showLoader } = this.props;
		removeError();
		if (type === 'library') {
			if (selectedFile) {
				showLoader();
				let data = {
					profileImgUrl: selectedFile.url,
					profileFileId: selectedFile._id,
					_id: this.state.creatorId,
				};
				updateBrandPicture(data).then(response => {
					this.clearFields();
				});
			} else {
				AlertJsMessage('Please select an image for the product picture.');
				return;
			}
		} else {
			if (previewImageSrc) {
				this.productFile.submitNewFile().then(file => {
					showLoader();
					let data = {
						profileImgUrl: file.url,
						profileFileId: file._id,
						_id: this.state.creatorId,
					};
					updateBrandPicture(data).then(response => {
						this.clearFields();
					});
				});
			} else {
				AlertJsMessage('Please select an image for the product picture.');
				return;
			}
		}
	}

	saveReferral() {
		const { type, selectedFile, previewImageSrc } = this.referralFile.state;
		const { updateReferenceCode, removeError, showLoader } = this.props;
		removeError();
		if (type === 'library') {
			if (selectedFile) {
				showLoader();
				let data = {
					referralImgUrl: selectedFile.url,
					referralFileId: selectedFile._id,
					_id: this.state.creatorId,
				};
				updateReferenceCode(data).then(response => {
					this.setState({
						creatorId: response._id,
					});
				});
			} else {
				AlertJsMessage('Please select an image for the referral picture.');
				return;
			}
		} else {
			if (previewImageSrc) {
				this.referralFile.submitNewFile().then(file => {
					showLoader();
					let data = {
						referralImgUrl: file.url,
						referralFileId: file._id,
						_id: this.state.creatorId,
					};
					updateReferenceCode(data).then(res => {
						this.setState({
							creatorId: res._id,
						});
					});
				});
			} else {
				AlertJsMessage('Please select an image for the referral picture.');
				return;
			}
		}
	}

	saveUser() {
		this.props.removeError();
		const { email, password, referenceCode, displayName, activeCompaignTag, isContentRestrict, isChatbot, isFullLibraryVisible, isLibraryExerciseHide } = this.state;
		const formData = {
			email,
			password,
			referenceCode,
			displayName,
			activeCompaignTag,
			isContentRestrict,
			isFullLibraryVisible,
			isChatbot,
			isLibraryExerciseHide,
			type: 'brand',
		};
		const required = ['email', 'password', 'referenceCode', 'displayName'];
		for (var i = 0; i < required.length; i++) {
			if (!formData[required[i]]) {
				AlertJsMessage(`${required[i]} is required.`);
				return;
			}
		}
		const { createUser } = this.props;
		createUser({ ...formData }).then(response => {
			this.setState({ creatorId: response._id });
		});
	}

	render() {
		return (
			<div>
				<NavigationTabs
					title="Manage Brands"
					set="manageBrands"
					subtitle="Add Feature Brand"
					activeRoute="/manageBrands/add"
				/>
				<div>
					<div>
						<div>
							<div
								style={{
									display: 'inline-flex',
									width: '100%',
									justifyContent: 'space-between',
								}}
							>
								<div style={{ width: '45%' }}>
									<TextField
										style={{ maxWidth: 820, marginTop: 10, marginRight: 10 }}
										label="Email"
										value={this.state.email}
										onChange={this.handleChange('email')}
										margin="dense"
										variant="outlined"
									/>
								</div>
								<div style={{ width: '45%' }}>
									<TextField
										style={{ maxWidth: 820, marginTop: 10, marginRight: 10 }}
										label="Password"
										value={this.state.password}
										onChange={this.handleChange('password')}
										margin="dense"
										variant="outlined"
									/>
								</div>
							</div>
							<div
								style={{
									display: 'inline-flex',
									width: '100%',
									justifyContent: 'space-between',
								}}
							>
								<div style={{ width: '45%' }}>
									<h4>Assign web referral link: www.Fitbanx.com/brand/</h4>
									<TextField
										style={{ maxWidth: 200, marginTop: 10, marginRight: 10 }}
										label=""
										value={this.state.referenceCode}
										onChange={this.handleChange('referenceCode')}
										margin="dense"
										variant="outlined"
									/>
								</div>
								<div style={{ width: '45%' }}>
									<h4>Display Name</h4>
									<TextField
										style={{ maxWidth: 200, marginTop: 10, marginRight: 10 }}
										label=""
										value={this.state.displayName}
										onChange={this.handleChange('displayName')}
										margin="dense"
										variant="outlined"
									/>
								</div>
							</div>
							<div
								style={{
									display: 'inline-flex',
									width: '100%',
									justifyContent: 'space-between',
								}}
							>
								<div style={{ width: '45%' }}>
									<h4>Active Campaign Tag</h4>
									<TextField
										style={{ maxWidth: 200, marginTop: 10, marginRight: 10 }}
										label=""
										value={this.state.activeCompaignTag}
										onChange={this.handleChange('activeCompaignTag')}
										margin="dense"
										variant="outlined"
									/>
								</div>

								<div style={{ width: '45%' }}>
									<h4>App Content</h4>
									<FormControlLabel
											control={
												<Checkbox
													onChange={this.handleRestrictApp('isContentRestrict')}
													defaultChecked={this.state.isContentRestrict}
													inputProps={{
														'name': 'isContentRestrict',
													}}
												/>
											}
											name = "isContentRestrict"
											label="Restrict App to this brand"
											/>
								</div>

								

							</div>

							<div
								style={{
									display: 'inline-flex',
									width: '100%',
									justifyContent: 'space-between',
								}}
							>
								

								<div style={{ width: '45%' }}>
									<h4>Show Full Fitbanx Library</h4>
									<FormControlLabel
											control={
												<Checkbox
													onChange={this.handleFullLibraryVisible('isFullLibraryVisible')}
													defaultChecked={this.state.isFullLibraryVisible}
													inputProps={{
														'name': 'isFullLibraryVisible',
													}}
												/>
											}
											name = "isFullLibraryVisible"
											label="Show Full Fitbanx Library to this brand"
											/>
								</div>

							
					
								
								<div style={{ width: '45%' }}>
									<h4>Hide Exercise From App's Library</h4>
									<FormControlLabel
											control={
												<Checkbox
													onChange={this.handleHideExerciseHide('isLibraryExerciseHide')}
													defaultChecked={this.state.isLibraryExerciseHide}
													inputProps={{
														'name': 'isLibraryExerciseHide',
													}}
												/>
											}
											name = "isLibraryExerciseHide"
											label="Hide Exercise From App's Library to this brand"
											/>
								</div>
								
							

							</div>

							<div
								style={{
									display: 'inline-flex',
									width: '100%',
									justifyContent: 'space-between',
								}}
							>
								<div style={{ width: '45%' }}>
									<h4>Show Chatbot</h4>
									<FormControlLabel
											control={
												<Checkbox
													onChange={this.handleChatbot('isChatbot')}
													defaultChecked={this.state.isChatbot}
													inputProps={{
														'name': 'isChatbot',
													}}
												/>
											}
											name = "isChatbot"
											label="Show Chat bot to this brand"
											/>
								</div>
								</div>

							<div style={{ width: '45%', marginTop: '10px' }}>
								<Button
									onClick={() => {
										this.saveUser();
									}}
									disabled={this.state.creatorId !== ''}
									variant="contained"
									color="primary"
								>
									<ButtonContent text="Save" icon="chevron-right" />
								</Button>
							</div>
							{this.state.creatorId && (
								<div>
									<hr />
									<h3>Referral Picture</h3>
									<div>
										<div>
											<h4>Upload Photo</h4>
											<FileSelection
												userData={{ _id: this.state.creatorId }}
												fileType="image"
												category="profile"
												isBrand={true}
												selectedFileId={this.state.referralFileId}
												ref={ref => {
													this.referralFile = ref
														? ref.getWrappedInstance()
														: null;
												}}
											/>
										</div>
									</div>
									<div style={{ width: '45%', marginTop: '10px' }}>
										<Button
											onClick={() => {
												this.saveReferral();
											}}
											variant="contained"
											color="primary"
										>
											<ButtonContent text="Save" icon="chevron-right" />
										</Button>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
				{this.state.creatorId && (
					<div>
						<hr />
						<h3>Product Picture</h3>
						<div>
							<div>
								<h4>Upload Product Picture Photo</h4>
								<FileSelection
									userData={{ _id: this.state.creatorId }}
									fileType="image"
									category="profile"
									imageCategory="product"
									selectedFileId={this.state.productFileId}
									ref={ref => {
										this.productFile = ref ? ref.getWrappedInstance() : null;
									}}
								/>
							</div>
						</div>
						<div style={{ width: '45%', marginTop: '10px' }}>
							<Button
								disabled={this.state.creatorId === ''}
								onClick={() => {
									this.updateBrand();
								}}
								variant="contained"
								color="primary"
							>
								<ButtonContent text="Save" icon="chevron-right" />
							</Button>
						</div>
					</div>
				)}
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		errors: state.errors,
	};
}
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		updateBrandPicture: data => {
			return dispatch(updateBrandPicture(data));
		},
		createUser: data => {
			return dispatch(createUser(data));
		},
		updateReferenceCode: data => {
			return dispatch(updateReferenceCode(data));
		},
		showLoader: () => {
			return dispatch(showLoader());
		},
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(AddBrand));



// WEBPACK FOOTER //
// ./src/components/manageBrands/BrandAdd.js